










































import Vue from "vue";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component
export default class SelectedAdvideos extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchAdvideos", { namespace }) fetchAdvideos: any;
  @Mutation("selectAdvideo", { namespace }) selectAdvideo: any;
  @Mutation("unSelectAdVideo", { namespace }) unSelectAdVideo: any;
  @Mutation("resetSelectedAdvideos", { namespace }) resetSelectedAdvideos: any;
  @Mutation("selectThumb", { namespace }) selectThumb: any;
  // computed variable based on user's email
}
